import "@/App.css";
import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { FeaturedProjects } from "@/components/FeaturedProjects";
import { About } from "@/components/About";
import { CinematicCTA } from "@/components/CinematicCTA";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Testimonials } from "@/components/Testimonials";
import { Team } from "@/components/Team";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

function App() {
  useSmoothScroll();
  return (
    <div className="App" data-testid="lenis-root">
      <Navbar />
      <main>
        <Hero />
        <FeaturedProjects />
        <About />
        <CinematicCTA />
        <WhyChooseUs />
        <Testimonials />
        <Team />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
